import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, FILTERS } from './consts';

export const getScenarios = path([$, LIST]);
export const getScenario = (id) => path([$, LIST, id]);
export const getScenarioProp = (id) => (name) => path([$, LIST, id, name]);
export const getScenariosFilters = path([$, FILTERS]);
